import { useIntl } from '@capsicum/common';

import { useGamificationBehaviors } from '../../useGamificationBehaviors';

export const useRewardPointsSnackbar = (amount: number, behaviorId?: string) => {
	const { $t, getLocalizedField } = useIntl();
	const { getBehaviorBy } = useGamificationBehaviors();

	const description = $t('snackbar.rewardPointsSnackbar.description', { amount: amount });
	const behavior = getBehaviorBy(b => b.id === behaviorId);

	const title = getLocalizedField('name', behavior || {}) ?? behavior?.name;

	return {
		intlText: {
			description,
			title
		}
	};
};
